import { type ReactNode } from 'react';
import { HStack, IconClose, Text, VStack } from '@direct-frontend/components';
import styles from './Toast.module.css';

export interface ToastProps {
    title: string;
    caption?: ReactNode;
    onClose: () => void;
}

export const Toast = (props: ToastProps) => {
    const { title, caption, onClose } = props;

    return (
        <HStack className={styles.toastText} justifyContent="flex-start">
            <VStack gap="2">
                <Text color="white">{title}</Text>

                {caption && (
                    <Text>
                        <span className={styles.caption}>{caption}</span>
                    </Text>
                )}
            </VStack>

            <IconClose className={styles.toastIcon} color="white" role="main" cursor="pointer" onClick={onClose} />
        </HStack>
    );
};
